import {genqlBuilder} from "@/core/graphql/genql/builder"

import {MutationGenqlSelection, VorderCouponResult} from "../schema"

import {MutationVorderCouponArgs} from "../schema"

export type MutationVorderCouponVars = MutationVorderCouponArgs

export function vorderCouponMutation(mutation: MutationGenqlSelection['vorder_coupon'] | null) {            
    return {
      build: (variables: MutationVorderCouponVars) => genqlBuilder.build(mutation ? {vorder_coupon: mutation} : {__scalar: true}, {vorder_coupon: variables}),  
      mutate: (variables: MutationVorderCouponVars) => ({} as Promise<VorderCouponResult>),
      _variables: {} as MutationVorderCouponVars,
      _result: {} as VorderCouponResult,
    }
}

export type MutationVorderCoupon = {
  builder: (variables: MutationVorderCouponVars) => MutationGenqlSelection,
  selection: MutationGenqlSelection['vorder_coupon'],
  variables: MutationVorderCouponVars,
  result: VorderCouponResult
}

export default vorderCouponMutation